import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import _ from 'underscore'
import cookie from '../lib/cookie'
import STATUS_CODE from '../constant/status_code'

const getCakeStoreCitys = (data) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    Api.get(`${CONSTANT.REQUEST_HOST}${query}`, {
        headers: {
          'X-Host': 'mall.card.cake-store-city-list',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status == STATUS_CODE.EMPTY_LIST) {
            return resolve([])
          } else if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}

const getCakeStore = (data) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    Api.get(`${CONSTANT.REQUEST_HOST}${query}`, {
        headers: {
          'X-Host': 'mall.card.cake-store-list',
          'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status == STATUS_CODE.EMPTY_LIST) {
            return resolve([])
          } else if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}

/*yeoman-template-point-1*/
export default {
  getCakeStoreCitys,
  getCakeStore,
  /*yeoman-template-point-2*/
}
